import React,{useState} from 'react'
import SLoader from '../../../Components/Loading/SigninLoader'
import Chats from '../Chat/Chat'
import Project from '../Chatdetails/Project'
import Projectdetails from '../Chatdetails/Projectdetails'
import TaskList from '../SingleTask/taskList'

const Taskdetails = ({clickedid, searchcriteria, unrole}) => {
    const [loading, setLoading] = useState(false)
    let clickedProject = TaskList.filter((projectDetails) => projectDetails.id === clickedid)
    delete clickedProject.discussion
  return (
    <div className='subb-task-containers'>
        {loading && <SLoader type="spin" color="red" text = "Fetching Data"/>}
            <div className='details-mn-container'>
                <Projectdetails taskdetails={clickedProject}/>
                {(searchcriteria === "details" || searchcriteria === "all") ?  <Project body={clickedProject} urole={unrole}/> : searchcriteria === "discussion" ? <Chats/> : <></>}
            </div> 
    </div>
  )
}

export default Taskdetails